import React, { createContext } from 'react';
import { useLazyQuery } from 'react-apollo';
import GET_USERS_BASIC_DETAILS from '../../GraphQl/Queries/GET_USERS_BASIC_DETAILS';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [
    fetchBasicUsersDetails,
    { data: basicUsersDetails, loading: basicUsersDetailsLoading, error },
  ] = useLazyQuery(GET_USERS_BASIC_DETAILS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  const [
    fetchRequestorUsers,
    { data: requestorData, loading: requestorLoading, error: requestorError },
  ] = useLazyQuery(GET_USERS_BASIC_DETAILS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  const [
    fetchCollaboratorsUsers,
    { data: collaboratorsData, loading: collaboratorsLoading, error: collaboratorsError },
  ] = useLazyQuery(GET_USERS_BASIC_DETAILS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  return (
    <UserContext.Provider
      value={{
        fetchBasicUsersDetails,
        basicUsersDetails: (basicUsersDetails && basicUsersDetails.users) || [],
        basicUsersDetailsLoading,
        error,
        fetchRequestorUsers,
        requestorData: (requestorData && requestorData.users) || [],
        requestorLoading,
        requestorError,
        fetchCollaboratorsUsers,
        collaboratorsData: (collaboratorsData && collaboratorsData.users) || [],
        collaboratorsLoading,
        collaboratorsError,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
